const OPEN_CLASS = 'menu-open';
const button = document.querySelector("[data-menu-button]");
const overlay = document.querySelector("[data-menu-open-overlay]");

function setMenuOpen(open) {
    document.body.classList.toggle(OPEN_CLASS, open);
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'Luk menu' : 'Åbn menu');    
}

function isMenuOpen() {
    return document.body.classList.contains(OPEN_CLASS);
}

if (button) {
    button.addEventListener('click', () => setMenuOpen(!isMenuOpen()));
    
    //luk ved click på overlay
    overlay?.addEventListener('click', () => setMenuOpen(false));

    //luk ved escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen()) {
            setMenuOpen(false);
            button.focus();
        }
    });
}